export default __webpack_public_path__ + "static/media/logo-haladiem.12298087.png";